import { ButtonBase } from '@mui/material';
import React from 'react';

export default function ToUsItem({ Icon, label, children, ...props }) {
	return (
		<a tw='border border-grey-E rounded-10' {...props}>
			<ButtonBase tw='relative rounded-10 px-20 py-24 flex items-center justify-center w-200'>
				<div className='absolute top-0 bg-light h-15 -mt-07 w-90 text-center'>{label}</div>
				<div><Icon /></div>
				<div className='ml-10 sm:font-bold text-14'>{children}</div>
			</ButtonBase>
		</a>
	);
}
